import axiosInstance from "../../config/AxiosConfig";
import {
  TransferListResp,
  TransferDetailResp,
} from "domain/payload/response/bankamar/TransferResp";

const TransferStatusService = () => {
  const getList = async (
    token: string,
    page?: number,
    size?: number,
    search?: string | null
  ): Promise<TransferListResp> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/cms/amar-integration/transfer-status/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            page,
            size,
            search,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const getDetail = async (
    token: string,
    id: string
  ): Promise<TransferDetailResp> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/cms/amar-integration/transfer-status/detail`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { id },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  return { getList, getDetail };
};

export default TransferStatusService;
